import http from "@/utils/request";

const port = {
  getPortList: (data) =>
    http.sendRequest({
      METHOD_NAME: "port.listAllPort",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default port;
